// ResetInputStyle.js
'use strict';
import { css } from 'styled-components';

export const ResetInputStyle = css`
  outline: none;
  border: none;
  border-radius: 0px;
  padding: 0px;
  background: none;
  &[type='range'] {
    cursor: pointer;
  }
`;

export default ResetInputStyle;
